import { State } from 'country-state-city';
import { ValidationError } from './errors';
import { ValidatePaymentInfoForStripeOptions } from './types';

export const validatePaymentInfoForStripe = async ({
  stripe,
  elements,
  billingDetails,
}: ValidatePaymentInfoForStripeOptions) => {
  if (!stripe || !elements) {
    // Do not allow form submission until stripe.js has loaded
    throw new ValidationError('Failed to load stripe elements');
  }

  // Trigger form validation and wallet collection
  const { error: submitError } = await elements.submit();
  if (submitError) {
    throw new ValidationError(
      `Payment submission failed with error: ${
        submitError.code ?? submitError.message ?? 'Something went wrong'
      }`,
      {
        silent: submitError.type === 'validation_error',
      },
    );
  }

  const customerName = [
    billingDetails?.firstName,
    billingDetails?.lastName,
  ].join(' ');

  const stateName =
    billingDetails?.state &&
    State.getStateByCodeAndCountry(billingDetails.state, billingDetails.country)
      ?.name;

  // Create the PaymentMethod
  const { error: stripeError, paymentMethod } =
    await stripe.createPaymentMethod({
      elements,
      params: {
        billing_details: {
          address: {
            city: billingDetails?.city,
            country: billingDetails?.country,
            line1: billingDetails?.address,
            line2: billingDetails?.unit ?? '',
            postal_code: billingDetails?.postalCode ?? '',
            state: stateName ?? '',
          },
          name: customerName,
        },
      } as const,
    });

  if (stripeError) {
    throw new ValidationError(
      `Payment method creation failed with error: ${
        stripeError.message ?? 'Something went wrong'
      }`,
    );
  }

  return paymentMethod;
};
